import React, { Fragment } from 'react';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import { useTranslation } from 'react-i18next';

const DonationListing = () => {
    const { t } = useTranslation();

    return (
        <Fragment>
            <Header hclass={'header--styleFour'} />
            <main className="main">
                <section className="supportOverview sitePageSection">
                    <div className="container">
                        <article className="supportOverview__content">
                            <h1>{t('donation_list.combined_title')}</h1>
                            <p>{t('donation_list.combined_text')}</p>
                            <p>
                                {t('donation_list.contact_text')}{' '}
                                <a href="mailto:info@kaed.org.tr">info@kaed.org.tr</a>
                            </p>
                            <div className="supportOverview__iban">
                                <span>{t('donation_list.iban_label')}</span>
                                <strong>KÜLTÜRLER ARASI ETKİLEŞİM DERNEĞİ</strong>
                                <code>TR45 0021 0000 0012 1819 4000 01</code>
                            </div>
                        </article>
                    </div>
                </section>
            </main>
            <Footer />
        </Fragment>
    );
};

export default DonationListing;
